import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Spin } from 'antd';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import DetailMain from './components/DetailMain/index';
import styles from './entry.module.less';
import { getClusterAndDirectTaskDetail } from '@/common/api/expandStore/clusterAndDirect';
import { getCircleTaskDetail } from '@/common/api/expandStore/expansionCircleTask';
import Header from './components/Header';

/**
 * 拓店任务-详情
 * @description 加盟+直营A（基诺浦）、加盟+直营B（一鸣）
 */
const Detail: FC<{
  id,
  // onClose?,
  reload?,
  isHistory?,
  hideOperate?,
  hideClusterDetail?,
  isLocxx?: boolean,
  ref?: any,
}> = forwardRef(({ id, reload, isHistory, hideOperate, hideClusterDetail, isLocxx = false }, ref) => {
  const [innerMainHeight, setInnerMainHeight] = useState<number>(0);
  const detailMainRef: any = useRef();
  const [loading, setLoading] = useState<boolean>(false);
  /** 弹窗内操作进行中（如机会点模型同步），用于遮罩整个详情弹窗 */
  const [operating, setOperating] = useState<boolean>(false);
  const [detail, setDetail] = useState<any>({});


  useImperativeHandle(ref, () => ({
    init: methods.init
  }));


  const methods = useMethods({

    /**
     * @description 初始化
     */
    init: () => {
      if (!id) {
        return;
      }
      methods.loadData(id);
    },

    loadData: async (id: number) => {
      setLoading(true);
      try {
        const data = isLocxx
          ? await getCircleTaskDetail({ id })
          : await getClusterAndDirectTaskDetail({ id });
        setDetail(data?.data || data);
      } finally {
        setLoading(false);
      }
    },

    /**
     * @description 重新加载
     * @param status 状态 true 需要加载详情， false 不需要加载详情
     * @return
     */
    reload(status = true) {
      if (status) methods.init();

      reload?.();
    }
  });

  return (<>
    <Spin tip={operating ? '处理中请稍等......' : '数据正在加载中请稍等......'} spinning={loading || operating}>
      <V2Container
        emitMainHeight={(h) => setInnerMainHeight(h)}
        extraContent={{
          top: <Header
            isHistory={isHistory}
            hideOperate={hideOperate}
            detail={detail}
            onRefresh={() => methods.reload(true)}
          />,
        }}
        style={{ height: 'calc(100vh - 48px)', width: '100%' }}
        className={styles.container}>

        <DetailMain
          ref={detailMainRef}
          style={{
            height: innerMainHeight || 'auto',
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
          detail={detail}
          hideOperate={hideOperate}
          hideClusterDetail={hideClusterDetail}
          isLocxx={isLocxx}
          onOperatingChange={setOperating}
          // onClose={onClose}
          refresh={() => methods.reload(true)} />
      </V2Container>
    </Spin>
  </>);
});

export default Detail;
